import DashboardRounded from '@mui/icons-material/DashboardRounded';
import DirectionsBikeRounded from '@mui/icons-material/DirectionsBikeRounded';
import EventNoteRounded from '@mui/icons-material/EventNoteRounded';
import PeopleAltRounded from '@mui/icons-material/PeopleAltRounded';
import QrCode2Rounded from '@mui/icons-material/QrCode2Rounded';
import Inventory2Rounded from '@mui/icons-material/Inventory2Rounded';
import AssignmentRounded from '@mui/icons-material/AssignmentRounded';
import ScienceRounded from '@mui/icons-material/ScienceRounded';
import DescriptionRounded from '@mui/icons-material/DescriptionRounded';
import ArticleRounded from '@mui/icons-material/ArticleRounded';
import FactCheckRounded from '@mui/icons-material/FactCheckRounded';
import SendRounded from '@mui/icons-material/SendRounded';
import OutboxRounded from '@mui/icons-material/OutboxRounded';
import MemoryRounded from '@mui/icons-material/MemoryRounded';
import ReceiptLongRounded from '@mui/icons-material/ReceiptLongRounded';
import PaymentsRounded from '@mui/icons-material/PaymentsRounded';
import AccountBalanceRounded from '@mui/icons-material/AccountBalanceRounded';
import HealthAndSafetyRounded from '@mui/icons-material/HealthAndSafetyRounded';
import HandshakeRounded from '@mui/icons-material/HandshakeRounded';
import CampaignRounded from '@mui/icons-material/CampaignRounded';
import InsightsRounded from '@mui/icons-material/InsightsRounded';
import LockClockRounded from '@mui/icons-material/LockClockRounded';
import ApartmentRounded from '@mui/icons-material/ApartmentRounded';
import TableChartRounded from '@mui/icons-material/TableChartRounded';
import ManageAccountsRounded from '@mui/icons-material/ManageAccountsRounded';
import AccountTreeRounded from '@mui/icons-material/AccountTreeRounded';
import SettingsRounded from '@mui/icons-material/SettingsRounded';

/**
 * Laboratory sidebar (docs/lab-module/06-frontend.md §2.3). Each item carries
 * the lab permission that reveals it; an array means ANY of them. `only`
 * restricts an item to one lab sub-role.
 */
export const LAB_NAV = [
  { label: 'Dashboard', path: '/lab/dashboard', icon: DashboardRounded, group: 'Operations', perm: 'dashboard' },
  { label: 'My round', path: '/lab/round', icon: DirectionsBikeRounded, group: 'Operations', perm: 'homecollection', only: 'phlebotomist' },
  { label: 'Appointments', path: '/lab/bookings', icon: EventNoteRounded, group: 'Operations', perm: ['bookings', 'homecollection'], countKey: 'bookings_today' },
  { label: 'Patients', path: '/lab/patients', icon: PeopleAltRounded, group: 'Operations', perm: 'patients' },
  { label: 'Specimens', path: '/lab/specimens', icon: QrCode2Rounded, group: 'Operations', perm: 'lab' },
  { label: 'Inventory & Purchases', path: '/lab/inventory', icon: Inventory2Rounded, group: 'Operations', perm: 'inventory' },
  { label: 'Worklist', path: '/lab/worklist', icon: AssignmentRounded, group: 'Laboratory', perm: 'worklist', countKey: 'results_to_verify' },
  { label: 'Test Catalog', path: '/lab/tests', icon: ScienceRounded, group: 'Laboratory', perm: 'tests' },
  { label: 'Reports', path: '/lab/reports', icon: DescriptionRounded, group: 'Laboratory', perm: 'reports' },
  { label: 'Report Templates', path: '/lab/report-templates', icon: ArticleRounded, group: 'Laboratory', perm: 'lab' },
  { label: 'Quality Control', path: '/lab/qc', icon: FactCheckRounded, group: 'Laboratory', perm: 'lab' },
  { label: 'Report Dispatch', path: '/lab/dispatch', icon: SendRounded, group: 'Laboratory', perm: 'dispatch' },
  { label: 'Send-outs', path: '/lab/send-outs', icon: OutboxRounded, group: 'Laboratory', perm: 'sendouts' },
  { label: 'Instruments', path: '/lab/instruments', icon: MemoryRounded, group: 'Laboratory', perm: 'instruments' },
  { label: 'Billing Counter', path: '/lab/billing', icon: ReceiptLongRounded, group: 'Revenue', perm: ['billing', 'billapproval'], countKey: 'approvals_pending' },
  { label: 'Collections', path: '/lab/collections', icon: PaymentsRounded, group: 'Revenue', perm: 'billing' },
  { label: 'Accounts', path: '/lab/accounts', icon: AccountBalanceRounded, group: 'Revenue', perm: 'accounts' },
  { label: 'TPA & Insurance', path: '/lab/tpa', icon: HealthAndSafetyRounded, group: 'Revenue', perm: 'tpa' },
  { label: 'Referral Payouts', path: '/lab/commissions', icon: HandshakeRounded, group: 'Revenue', perm: 'accounts' },
  { label: 'Campaigns', path: '/lab/campaigns', icon: CampaignRounded, group: 'Revenue', perm: 'campaigns' },
  { label: 'MIS & Analytics', path: '/lab/analytics', icon: InsightsRounded, group: 'Revenue', perm: 'analytics' },
  { label: 'Day Close', path: '/lab/day-close', icon: LockClockRounded, group: 'Revenue', perm: 'dayclose' },
  { label: 'Clients & Tie-ups', path: '/lab/clients', icon: ApartmentRounded, group: 'Masters', perm: 'clients' },
  { label: 'Tariffs & Rate Cards', path: '/lab/tariffs', icon: TableChartRounded, group: 'Masters', perm: 'tariffs' },
  { label: 'Users & Access', path: '/lab/users', icon: ManageAccountsRounded, group: 'Masters', perm: 'users' },
  { label: 'Workflow Builder', path: '/lab/workflows', icon: AccountTreeRounded, group: 'Masters', perm: 'workflows' },
  { label: 'Settings', path: '/lab/settings', icon: SettingsRounded, group: 'Masters', perm: 'settings' },
];

/**
 * Lab items a lab staff member sees: by permission, and `only` by sub-role. A phlebotomist sees their
 * own Dashboard and My round, plus Appointments (the round planner) when they also hold `bookings`.
 */
const AGENT_PAGES = ['/lab/dashboard', '/lab/round'];
export const labNavFor = (can, labRole) => {
  const items = LAB_NAV.filter((i) => can(i.perm) && (!i.only || labRole === i.only));
  if (labRole !== 'phlebotomist') return items;
  return items.filter((i) => AGENT_PAGES.includes(i.path) || (i.path === '/lab/bookings' && can('bookings')));
};

/**
 * Lab groups appended to the hospital admin's sidebar, at the bottom, under
 * "Lab · …" group names. None when the hospital has no enabled lab.
 */
export const hospitalAdminLabNav = (labEnabled) =>
  labEnabled
    ? LAB_NAV.filter((i) => !i.only).map((i) => ({ ...i, group: `Lab · ${i.group}` }))
    : [];
